module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "rabb",
      "title": "Abbreviations"
    }
  }, [_c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xv",
      "title": "xv"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253041401_Contents#abb"
    }
  }, [_c('b', [_vm._v("ABBREVIATIONS")])])])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("APS")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "80%"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("American Philosophical Society")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("ARCIA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Annual Reports")]), _vm._v(" of the [United States] Commissioner of Indian Affairs")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("BL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Beinecke Library")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("BIA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Bureau of Indian Affairs")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("CCF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Central Classified Files")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("COLL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Collection")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("EW")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Eleazer Williams")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("GBAR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Green Bay Agency Records")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("HC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Hamilton College, Clinton, New York")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("ICC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Indian Claims Commission")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("JAJ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("John Archiquette Journals")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("JAPR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("John Archiquette Police Reports")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("JFC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("James Fenimore Cooper")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("JR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Jesuit Relations and Allied Documents")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("M")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Microcopy")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("MR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Microfilm Reel")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("MSS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Manuscript Collection")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("NA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("National Archives")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("NYIA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("New York Indian Agency")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("NYSA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("New York State Archives")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("NYSL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("New York State Library")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("OIA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Office of Indian Affairs")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("OLFP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Oneida Language and Folklore Project")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("ONIW")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Oneida Nation of Indians of Wisconsin")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("REV")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Reverend")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("RG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Record Group")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Rt. Rev.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Right Reverend/Bishop")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("SK")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Samuel Kirkland")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvi",
      "title": "xvi"
    }
  }, [_vm._v("SPG")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Society for the Propagation of the Gospel in Foreign Parts")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Stat.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("United States Statutes at Large")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("USGPO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("United States Government Printing Office")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("UWGB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("University of Wisconsin at Green Bay")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Very Rev.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Very Reverend/Senior Priest")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("WHC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Wisconsin Historical Collections")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("WHS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Wisconsin Historical Society")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("WHSARC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Wisconsin Historical Society Area Research Center")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("WPA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Works Progress Administration")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("YU")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Yale University")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52cd3d9d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253041401_Abbreviations.vue
// module id = 81
// module chunks = 0